import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div data-testid="not-found-page" className="text-center max-w-lg">
        <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#B8960C] mb-6">
          Page Not Found
        </p>
        <h1
          className="font-heading text-6xl md:text-8xl font-light text-[#1A1A1A] uppercase mb-4"
          style={{ letterSpacing: '0.1em' }}
        >
          404
        </h1>
        <div className="w-16 h-px bg-[#B8960C] mx-auto my-8 opacity-40"></div>
        <p className="text-base text-[#6B7280] font-light leading-relaxed mb-10">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          data-testid="not-found-home-button"
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-transparent border border-[#B8960C] text-[#B8960C] hover:bg-[#B8960C] hover:text-white transition-colors duration-300 px-8 py-4 uppercase tracking-[0.2em] text-xs font-medium"
        >
          <ArrowLeft size={14} strokeWidth={1.5} />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
